import {StandardFeature} from 'auth/capabilities/CapabilityConstants';
import {
  Capability,
  FeatureWithoutPermissionsMapping,
  USER_PREFERENCE_GATED_CAPABILITIES,
  UserPreferenceGatedCapability,
} from 'auth/capabilities/CapabilityFeatureConstants';
import {
  getCapabilityFeatureFromStandardFeature,
  legacyIsCapabilityEnabled,
} from 'auth/capabilities/getCapabilityFeatures';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import {Section, SECTIONS, SidepanelSection} from 'constants/NavConstants';

export const NAV_SECTION_TO_CAPABILITY = {
  [SECTIONS.ANALYTICS]: Capability.INSIGHTS,
  [SECTIONS.REGISTRIES]: Capability.REGISTRY,
  [SECTIONS.REQUESTS]: Capability.REQUESTS,
  [SECTIONS.STORAGE]: Capability.INVENTORY,
  [SECTIONS.WORKFLOWS]: Capability.WORKFLOWS,
  [SECTIONS.WORKLISTS]: Capability.REGISTRY,
  [SECTIONS.WORKLIST_ITEMS]: Capability.REGISTRY,
};

const INITIALLY_UNLOADABLE_SECTIONS = [
  // WORKLIST_ITEMS can only be navigated to manually because we don't track the last viewed worklist item
  SECTIONS.WORKLIST_ITEMS,
];

export function getUnloadableSections(): Array<SidepanelSection> {
  const inaccessibleSections = Object.entries(NAV_SECTION_TO_CAPABILITY)
    .filter(([_, capability]) => !isSidepanelSectionDiscoverable(capability))
    .map(([section, _]) => section as Section);

  return [...inaccessibleSections, ...INITIALLY_UNLOADABLE_SECTIONS];
}

function isSidepanelSectionDiscoverable(capability: Capability): boolean {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (USER_PREFERENCE_GATED_CAPABILITIES.includes(capability as any)) {
    return legacyIsCapabilityEnabled(capability as UserPreferenceGatedCapability);
  }
  const feature = getCapabilityFeatureFromStandardFeature(capability, StandardFeature.DISCOVER);
  return isFeatureEnabled({feature: feature as FeatureWithoutPermissionsMapping});
}
